(() => {
  const ROOT_SELECTOR = '.product--new-standard sh-bundle.sh-bundle';
  const MAX_BOOT_ATTEMPTS = 20;
  const BOOT_INTERVAL_MS = 250;

  const parseMoneyToCents = (value) => {
    if (value == null || value === '') return null;
    const raw = String(value).trim();
    if (!raw) return null;
    if (/^\d+$/.test(raw)) return parseInt(raw, 10);

    const normalized = raw
      .replace(/[^\d,.-]/g, '')
      .replace(/\.(?=\d{3}(\D|$))/g, '')
      .replace(',', '.');
    const num = Number.parseFloat(normalized);
    if (Number.isNaN(num)) return null;
    return Math.round(num * 100);
  };

  const formatMoneyFromCents = (cents) => {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return `${amount} €`;
  };

  const setTextIfChanged = (el, next) => {
    if (!el || el.textContent.trim() === next) return;
    el.textContent = next;
  };

  const getOfferTotalCents = (block) => {
    const base = parseMoneyToCents(block.dataset.basePrice);
    const discountType = block.dataset.discountType;
    const discountValue = Number.parseFloat(block.dataset.discountValue || '0') || 0;

    if (base != null) {
      if (discountType === 'percentage' && discountValue > 0) {
        return Math.round(base * (1 - discountValue / 100));
      }
      if (discountType === 'fixed' && discountValue > 0) {
        return Math.max(0, base - Math.round(discountValue * 100));
      }
      return base;
    }

    return parseMoneyToCents(block.querySelector('[data-price]')?.textContent);
  };

  const enhanceBlock = (block) => {
    const info = block.querySelector('.sh-bundle-block-content-item-product-content-info');
    const priceEl = block.querySelector('[data-price]');
    const discountEl = block.querySelector('.sh-bundle-block-content-item-price-discount');
    const subtitle = info?.querySelector('.sh-bundle-block-content-item-product-content-info-subtitle');
    if (!info || !priceEl) return;

    const qty = Number.parseInt(block.dataset.quantity || '1', 10) || 1;
    const totalCents = getOfferTotalCents(block);
    if (totalCents == null || qty < 1) return;

    const unitCents = Math.round(totalCents / qty);
    let unitEl = info.querySelector('.sh-ns-unit-price');
    if (!unitEl) {
      unitEl = document.createElement('div');
      unitEl.className = 'sh-ns-unit-price';
      if (subtitle) info.insertBefore(unitEl, subtitle);
      else info.appendChild(unitEl);
    }
    setTextIfChanged(unitEl, formatMoneyFromCents(unitCents));
    setTextIfChanged(priceEl, formatMoneyFromCents(totalCents));
    setTextIfChanged(subtitle, 'pro Stück');

    if (discountEl) {
      const raw = (block.dataset.discountValue || discountEl.textContent || '').toString();
      const match = raw.match(/(\d+(?:[.,]\d+)?)/);
      if (match) {
        setTextIfChanged(discountEl, `Sparst ${match[1].replace('.', ',')}%`);
      }
    }
  };

  const enhanceBundle = (bundle) => {
    if (!bundle) return;
    bundle.classList.add('sh-bundle--new-standard');
    bundle.querySelectorAll('.sh-bundle-block').forEach(enhanceBlock);
  };

  const refreshAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(enhanceBundle);
  };

  const isNewStandardBundle = (bundle) =>
    !!bundle &&
    bundle.matches('sh-bundle.sh-bundle') &&
    !!bundle.closest('.product--new-standard');

  const bindInteractions = () => {
    document.addEventListener(
      'change',
      (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
        const bundle = input.closest('sh-bundle');
        if (isNewStandardBundle(bundle)) enhanceBundle(bundle);
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const card = event.target.closest?.('.sh-bundle-block-content');
        if (!card) return;
        const bundle = card.closest('sh-bundle');
        if (!isNewStandardBundle(bundle)) return;
        // App updates selected state after the click; refresh once on next frame.
        window.requestAnimationFrame(() => enhanceBundle(bundle));
      },
      true
    );
  };

  const boot = () => {
    refreshAll();

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      const bundles = document.querySelectorAll(ROOT_SELECTOR);
      if (bundles.length) {
        bundles.forEach(enhanceBundle);
        window.clearInterval(timer);
        return;
      }
      if (attempts >= MAX_BOOT_ATTEMPTS) window.clearInterval(timer);
    }, BOOT_INTERVAL_MS);
  };

  const ready = () => {
    bindInteractions();
    boot();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
